import { css } from '@emotion/css';
import { memo } from 'react';

interface Props {
    title: string;
    value: string;
    onChangeText?: (_: string) => void;
    disabled?: boolean;
    password?: boolean;
}

function InputAccount(props: Props) {
    const { title, value, onChangeText, disabled, password, ...rest } = props;

    return (
        <div className={styles.container}>
            <label className="labelInput">{title}</label>
            <input type={password ? 'password' : 'text'} {...rest} className="inputValue" value={value} disabled={disabled} onChange={(e) => onChangeText?.(e.target.value)} />
        </div>
    );
}

export default memo(InputAccount);

const styles = {
    container: css`
        background-color: white;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 20px;
        align-self: center;
        .inputValue {
            padding: 0 8px;
            border: 0;
            border-bottom: 1px solid #000;
            height: 35px;
            width: 500px;
            outline: none;
            font-size: inherit;
        }
        .labelInput {
            font-size: 17px;
            font-weight: 300;
            width: 200px;
            text-align: right;
        }
    `,
};
